export default function EditPencilIcon({ width = 20, height = 22, className, style, stroke = '#EAEAEA' }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 22"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M2.07973 11.4027L12.8943 0.588121L17.0538 4.74757L6.23918 15.5621L2.07975 15.5621L2.07973 11.4027Z"
                stroke={stroke}
                strokeWidth="1.17647"
                strokeLinejoin="round"
            />
            <line
                x1="2.05887"
                y1="20.2954"
                x2="19.1177"
                y2="20.2954"
                stroke={stroke}
                strokeWidth="1.76471"
                strokeLinecap="round"
            />
        </svg>
    );
}
